module.exports = __webpack_public_path__ + "static/img/appointment-calendar.7ea7e76.svg";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/appointment-calendar.svg
// module id = cl8b
// module chunks = 1